import {invoiceSvg as Icon__small__invoiceSvg} from '../Icon__small/Icon__small--invoice.js'
import {invoiceSvg as Icon__xsmall__invoiceSvg} from '../Icon__xsmall/Icon__xsmall--invoice.js'

export var invoice = {
  name: 'invoice',
  category: 'icon',
  colorable: true,
  svg: Icon__small__invoiceSvg,
  alt: {
    Icon__small: Icon__small__invoiceSvg,
    Icon__xsmall: Icon__xsmall__invoiceSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
